import React from 'react';
import { RouteObject } from 'react-router-dom';
import { IndividualsPage } from './views';

export const routes: RouteObject[] = [
  { path: 'individuals', element: <IndividualsPage /> }
];

export default routes;